import React from 'react';
import { Link } from 'react-router-dom';
import LanguageSpan from 'src/components/atoms/LanguageSpan';
import { ProjectListHeaderProps } from 'src/store/projectsOverview/projectsOverviewStore.types';
import { useBaseUrlStore } from 'src/StoreDataProvider';

const ProjectListHeader: (props: ProjectListHeaderProps) => JSX.Element = ({
  onCollapseChange,
  projectName,
  isSub,
  id,
}) => {
  const { path } = useBaseUrlStore();
  const detailsUrl = `/${path}/detail/${id}`;
  if (isSub) {
    return (
      <button className="subproject_acc" onClick={() => onCollapseChange()}>
        <div className="subproject_acc__icon-wrapper" aria-hidden="true">
          <em className="icon-plus" />
        </div>
        <h3 data-cy="subproject-tile-name">{projectName}</h3>
      </button>
    );
  }
  return (
    <Link
      className="project-tile-header-anker"
      to={detailsUrl}
      data-cy="project-tile-name"
    >
      <h2>
        <LanguageSpan
          text={projectName}
          keyPrefix={'project-tile-name'}
        ></LanguageSpan>
      </h2>
    </Link>
  );
};
export default ProjectListHeader;
